import { render, staticRenderFns } from "./AuthAcceptInvitationView.vue?vue&type=template&id=1ddb4bac"
import script from "./AuthAcceptInvitationView.vue?vue&type=script&lang=ts"
export * from "./AuthAcceptInvitationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports